var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isRequestActive,
          expression: "isRequestActive",
        },
      ],
      staticClass: "wrapper mt-2",
    },
    [
      _vm.listEmpty
        ? _c("div", { staticClass: "text-center" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.list, function (item) {
        return _c("schedule-item", {
          key: item.model.id,
          attrs: { model: item.model, settings: item.settings },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [
      _c("span", { staticClass: "badge badge-secondary" }, [
        _vm._v("There are no messages yet"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }